import React from "react";
import { css } from "@emotion/core";
import { StaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

// eslint-disable-next-line react/prop-types
export default ({ cssProp }) => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(
          relativePath: { eq: "logos/anana-vestige-logo-gold-text.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        loading="eager"
        css={css`
          ${cssProp}
        `}
        fluid={data.placeholderImage.childImageSharp.fluid}
      />
    )}
  />
);
